import React from 'react';

import SidebarPanel from 'ff/debrief/layouts/SidebarPanel';

import SidebarTabs, { SHARED } from './SidebarTabs';
import SharedTracklogList from './SharedTracklogList';

const SharedSidebar = () => {
    return (
        <SidebarPanel>
            <SidebarTabs currentTab={SHARED} />
            <SharedTracklogList />
        </SidebarPanel>
    );
};

export default SharedSidebar;
